/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Criticality_InvalidInputs */

const es_co2_error_criticality_invalid = /** @type {(inputs: Error_Criticality_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La criticidad seleccionada no es válida.`)
};

/**

* @param {Error_Criticality_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_criticality_invalid = /** @type {((inputs?: Error_Criticality_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Criticality_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_criticality_invalid(inputs)
});